import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Link from 'next/link';
import Head from "next/head";
import BannerNews from "../../components/BannerNews/BannerNews";
import { returnTrue } from "../../helpers/returnTrue";
import Layout from "../../Layout";
import NewsCatalog from "../../components/NewsCatalog/NewsCatalog";
import { useAppSelector } from "../../store/store";
import { GetStaticPaths, GetStaticProps } from "next";
import { axiosServer } from "../../axios/axiosCustom";
import { API_SSR } from "../../api/api";
import { useGetNewsQuery } from "../../store/api/newsApi"
import { INewsCategories, INewsCatalog } from "../../interfaces/newsCatalog.interface"
import BannerSks from "../../components/BannerSks/BannerSks";

const NewsCatalogAll = ({
                     news,
                     categories
                   }: PageProps) => {
  const page = useAppSelector((state) => state.newsReducer.page);
  const pageSize = useAppSelector((state) => state.newsReducer.pageSize);

  const { data: newsQuery, isFetching } = useGetNewsQuery({
    page,
    pageSize,
  });
  return (
    <>
      <Head>
        <title>
          SPL Group - Блог
        </title>
        <meta
          name="description"
          content="Сюда пиши сео"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Сюда пиши сео"
        />
        <meta
          property="og:description"
          content="Сюда пиши сео"
        />
      </Head>
      <Layout globalSettings={news.global_settings}>
        <BannerNews />
        <NewsCatalog
          isLoading={isFetching}
          countNews={news.meta.total}
          categories={categories}
          news={newsQuery ? newsQuery : news}
        />
      </Layout>
    </>
  );
};

export const getStaticProps: GetStaticProps<PageProps> = async ({ params }) => {
  try {
    const { data: news } = await axiosServer.get<INewsCatalog>(
      API_SSR.getNewsByCategory(
        `per_page=1000`
      )
    );
    const { data: categories } = await axiosServer.get<INewsCategories>(
      API_SSR.getNewsCategories
    );
    if (!categories || !news) {
      return {
        notFound: true,
        revalidate: 60,
      };
    }
    return {
      props: {
        categories,
        news,
      },
      revalidate: 60,
    };
  } catch (e) {
    console.log(e);
    return {
      notFound: true,
      revalidate: 60,
    };
  }
};

interface PageProps {
  news: INewsCatalog;
  categories: INewsCategories;
}

export default NewsCatalogAll;
